<template>
    <rkm-modal
        ref="Modal"
        title="Opções de impressão"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-if="form.impressoes.length > 1"
                        :indeterminate="indeterminate"
                        :value="true"
                        @change="checkUncheckAll"
                        v-model="checkedAll"
                    >
                        Todos
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="form.impressoes"
                        class="mb-0"
                        stacked
                        v-model="model.impressoes"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close">
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="model.impressoes.length === 0 || !!loading"
                @click="print"
                color="primary"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { error, file, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
            impressao: this.getConectaSusRepository('impressao.regulacao'),
            impressaoAmbulatorio: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        checkedAll: false,
        indeterminate: false,
        solicitacao: null,
        form: { impressoes: [] },
        model: { impressoes: [] },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(solicitacao) {

            this.solicitacao = solicitacao

            this.form.impressoes = [],
            this.model.impressoes = [],

            this.load()
            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.fila.getImpressoes({ solicitacao_id: this.solicitacao.id })
                .then(({ data }) => this.form.impressoes = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        checkUncheckAll(value) {

            this.model.impressoes = value ? this.form.impressoes.map(impressao => impressao.value) : []
        },
        print() {

            const items = {
                solicitacao: () => this.repositories.impressao.solicitacaoRegulacao(this.solicitacao.id),
                preparo: () => this.repositories.impressao.preparo(this.solicitacao.id),
                fichaRequisicaoServicoAuxiliarDiagnoseTerapia: () => this.repositories.impressaoAmbulatorio
                    .fichaRequisicaoServicoAuxiliarDiagnoseTerapia(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
                servicoAnaliseDiagnosticoTerapiaSolicitacaoExame: () => this.repositories.impressaoAmbulatorio
                    .servicoAnaliseDiagnosticoTerapiaSolicitacaoExame(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
                laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial: () => this.repositories.impressaoAmbulatorio
                    .laudoSolicitacaoAutorizacaoProcedimentoAmbulatorial(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
                encaminhamento: () => this.repositories.impressaoAmbulatorio
                    .encaminhamento(this.solicitacao.ambulatorioAtendimentoId, {
                        regulacao_solicitacao_id: this.solicitacao.id,
                    }),
            }

            this.model.impressoes.forEach(impressao => {

                if (impressao in items) {

                    this.setLoading()

                    items[impressao]()
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
        close() {

            this.$refs.Modal.hide()
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.impressoes'(value) {

            this.checkedAll = value.length > 0 && value.length == this.form.impressoes.length
            this.indeterminate = value.length > 0 && value.length != this.form.impressoes.length
        },
    },
}
</script>